import { Box, Container, Grid, useTheme } from "@mui/material";
import React from "react";
import { Base } from "../../base";
import { useSelector } from "../../../store";
import Attachment from "../../../types/attachment";
import SitesDialog from "../../../types/sitesDialog";
import { GridCellParams } from "@mui/x-data-grid";
import ColumnDef from "../../../types/columnDef";
import { useNavigate } from "react-router-dom";

interface Props {
  uploadFiles: (files: File[]) => void;
  setDeleteModal: React.Dispatch<React.SetStateAction<SitesDialog>>;
  handleDownload: (id: number) => void;
  setHighlightId: React.Dispatch<React.SetStateAction<number>>;
  highlightId: number;
}

const SiteAttachmentTable: React.FC<Props> = (props) => {
  const {
    uploadFiles,
    setDeleteModal,
    handleDownload,
    setHighlightId,
    highlightId,
  } = props;
  const theme = useTheme();
  const { siteAttachments, status } = useSelector((store) => store.attachments);
  const navigate = useNavigate();

  const columns: ColumnDef[] = [
    {
      field: "name",
      headerName: "Name",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      mobileSize: 12,
    },
    {
      field: "job",
      headerName: "Attached To",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      mobileSize: 12,
    },
    {
      field: "actions",
      headerName: "Actions",
      headerAlign: "center",
      align: "center",
      flex: 1,
      headerClassName: "header",
      sortable: false,
      disableColumnMenu: true,
      disableExport: true,
      filterable: false,
      renderCell: (params) => <>{params.value}</>,
      mobileSize: 12,
    },
  ];

  const displayRows = (array: any[]) => {
    return array.map((attachment: Attachment) => {
      let rowObject = {
        id: attachment.id,
        name:
          attachment?.name?.length! > 40
            ? `${attachment.name?.slice(0, 40)}...${
                attachment.name?.split(".")[1]
              } `
            : attachment?.name,
        // mobileTitle:
        //   attachment?.name?.length! > 40
        //     ? `${attachment.name?.slice(0, 40)}...${
        //         attachment.name?.split(".")[1]
        //       } `
        //     : attachment?.name,
        job: attachment.job?.value || "Site",
        jobId: attachment.job?.id,
        actions: (
          <Base.TableActions
            id={attachment?.id!}
            handleView={
              attachment.viewable
                ? () =>
                    window.open(attachment.url, "_blank", "noopener,noreferrer")
                : undefined
            }
            handleDownload={handleDownload}
            handleDelete={() => {
              setDeleteModal({
                visible: true,
                dialog: "attachments",
                id: attachment.id,
                name: attachment.name,
              });
              setHighlightId(attachment.id!);
            }}
          />
        ),
      };
      return rowObject;
    });
  };

  const onCellClick = (params: any) => {
    if (params.field === "job" && params.formattedValue !== "Site") {
      navigate(`/job/view/${params.row.jobId}`);
    }
  };

  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <Container>
          <Base.Dropzone onDrop={uploadFiles} />
        </Container>
      </Grid>
      {!!siteAttachments.length && (
        <Grid
          size={{ xs: 12 }}
          pb={{ xs: 15, md: 5 }}
          sx={{
            "& .header": {
              backgroundColor: theme.palette.primary.light,
              color: theme.palette.primary.contrastText,
            },
            "& .link": {
              cursor: "pointer",
            },
          }}
        >
          <Box
            sx={{
              display: { sm: "flex", xs: "none" },
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Base.Text text="Attachments" variant="h3" />
          </Box>
          <Base.TableContainer
            columns={columns}
            mobileRows={displayRows(siteAttachments)}
            rows={displayRows(siteAttachments)}
            pageSize={10}
            totalRows={siteAttachments.length}
            loading={status === "loading"}
            highlightId={highlightId}
            onCellClick={onCellClick}
            getCellClassName={(params: GridCellParams<any, any, any>) => {
              return params.field === "job" ? "link" : "";
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SiteAttachmentTable;
